function convertStrToBoolean(input) {
  if (typeof input === 'string') {
    return input === 'true';
  }
  return input;
}

export default convertStrToBoolean;
